import React from 'react';
import './Footer.css';
import { FaGithub, FaLinkedin, FaKaggle } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'About', href: '#about' },
    { name: 'Experience', href: '#experience' },
    { name: 'Projects', href: '#projects' },
    { name: 'Contact', href: '#contact' }
  ];

  const socialLinks = [
    { name: 'GitHub', icon: <FaGithub />, url: 'https://github.com/sanjay2320', color: '#9ca3af' },
    { name: 'LinkedIn', icon: <FaLinkedin />, url: 'https://linkedin.com/in/-sanjay/', color: '#38bdf8' },
    { name: 'Kaggle', icon: <FaKaggle />, url: 'https://www.kaggle.com/sanjay2311', color: '#22d3ee' }
  ];

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId.replace('#', ''));
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-shell">
          <div className="footer-brand">
            <span className="footer-kicker">Data Science & ML Portfolio</span>
            <h3 className="footer-name">Turning data into decisions.</h3>
            <p className="footer-description">
              Analytics, dashboards, and machine learning systems built for real business impact.
            </p>
            <div className="footer-social">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  style={{ '--social-color': social.color }}
                  title={social.name}
                >
                  {social.icon}
                  <span>{social.name}</span>
                </a>
              ))}
            </div>
          </div>

          <div className="footer-column">
            <h4 className="footer-title">Navigate</h4>
            <ul className="footer-links">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <button className="footer-link" onClick={() => scrollToSection(link.href)}>
                    {link.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

        </div>

        <div className="footer-bottom">
          <p className="copyright">© {currentYear} Sanjay. All rights reserved.</p>
          <a href="mailto:sanjaysakthi2311@gmail.com" className="footer-bottom-link">sanjaysakthi2311@gmail.com</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
